import * as React from "react";
import { useState } from "react";

// Material UI Components
import { Box, Typography } from "@mui/material";

// WhatsApp Components
import TemplateAnalyticsTable from "./TemplateAnalyticsTable";
import TemplateAnalyticsTab from "./TemplateAnalyticsTab";

// Shared Utils/Components
import BackButton from "../../common/back-button";
import typography from "../../cssUtils/typography";
import { ColorsConstants } from "../../cssUtils/constants";

const TemplateAnalytics = (props) => {
  // --- View State (List vs Detail) ---
  const [showAnalytics, setShowAnalytics] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Used for global context if needed by parent
  const [templatesNamesData, setTemplatesNamesData] = useState([]);

  // --- Handlers ---
  const handleTemplateClick = (template) => {
    setSelectedTemplate(template);
    setShowAnalytics(true);
  };

  const handleBackToTable = () => {
    setShowAnalytics(false);
    setSelectedTemplate(null);
  };

  return (
    <div className="App">
      <Box sx={{ mt: 3, mb: 1, mx: 3 }}>
        
        {/* --- Header (Only show when in List View) --- */}
        {!showAnalytics && (
          <>
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ ...typography.h1, mb: 0.5, fontWeight: 500, color: ColorsConstants.primaryBlue100 }}>
                Template Analytics
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Track delivery, read rates, and performance for your WhatsApp templates.
              </Typography>
            </Box>

            <TemplateAnalyticsTable
              refreshKey={props.refreshKey}
              setTemplatesNamesData={setTemplatesNamesData}
              onTemplateClick={handleTemplateClick}
            />
          </>
        )}

        {/* --- Detailed Analytics View (Drill-down) --- */}
        {showAnalytics && selectedTemplate && (
          <>
            <Box sx={{ mt: 3, mb: 3 }}>
              <BackButton onClick={handleBackToTable} />
            </Box>

            <TemplateAnalyticsTab template={selectedTemplate} />
          </>
        )}

      </Box>
    </div>
  );
};

export default TemplateAnalytics;